import React, { useEffect, useState } from "react";
//import { MDBContainer, MDBInput} from 'mdb-react-ui-kit';
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import company from "../assets/images/company.svg";
import driverId from "../assets/images/driver-id.svg";
import password from "../assets/images/password.svg";
import signIn from "../assets/images/sign-in (1).svg";
import Logo from "../assets/images/care-tap.png";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { BASE_API_URI } from "../constant";

const Login = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState({
    user_id: "",
    password: "",
    company_id: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Set loading state to true when form is submitted
    setIsLoading(true);

    try {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshtoken");
      localStorage.removeItem("userData");
      const response = await axios.post(`${BASE_API_URI}/login`, user);

      if (response && response?.data?.status === 200) {
        setIsLoading(false);
        const token = response.data.token;
        const refreshToken = response.data.refreshtoken;
        const expireTime = response.data.expireTime;
        localStorage.setItem("token", JSON.stringify(token));
        localStorage.setItem("refreshtoken", JSON.stringify(refreshToken));
        localStorage.setItem("userData", JSON.stringify(response.data.data));
        localStorage.setItem("expireTime", JSON.stringify(expireTime));
        const userData = JSON.parse(localStorage.getItem("userData"));
        // Role mapping: 1 = Administrator, 2 = Agency (both are admins)
        // Both should navigate to agency list
        if (userData.user_role === 1) {
          navigate("home/agency/list", { replace: false });
        } else {
          navigate("/home/dashboard", { replace: false });
        }
      } else {
        toast.error(response?.data?.message, { position: "top-center" });
        setIsLoading(false); // Reset loading state on error
      }
    } catch (error) {
      console.error("Error logging in:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "An error occurred during login";
      toast.error(errorMessage, { position: "top-center" });
      setIsLoading(false); // Reset loading state on error
    }
  };

  const userInput = (event) => {
    const { name, value } = event.target;
    setUser((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  return (
    <div className="login-wrapper">
      <div className="container">
        <section>
          <div className="row justify-content-center">
            <div className="col-md-8 col-sm-12 col-lg-5">
              <div className="card">
                <ToastContainer />
                <div className="header-icon">
                  <img
                    src={signIn}
                    className="img-fluid"
                    width="80"
                    height="80"
                    alt="sign in"
                  />
                </div>
                <div className="card-body p-5">
                  <div className="signin-header">
                    <h1>Sign In</h1>
                  </div>
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3 position-relative">
                      <div className="input-icon">
                        <img
                          src={company}
                          className="img-fluid"
                          width="20"
                          height="20"
                          alt="company id"
                        />
                      </div>
                      <input
                        type="text"
                        autoComplete="off"
                        className="form-control"
                        id="company-id"
                        value={user.company_id}
                        name="company_id"
                        placeholder="Company ID"
                        onChange={userInput}
                      />
                    </div>
                    <div className="mb-3 position-relative">
                      <div className="input-icon">
                        <img
                          src={driverId}
                          className="img-fluid"
                          width="20"
                          height="20"
                          alt="driver id"
                        />
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        autoComplete="off"
                        id="user_id"
                        value={user.user_id}
                        name="user_id"
                        placeholder="Username"
                        onChange={userInput}
                      />
                    </div>
                    <div className="pb-4 position-relative">
                      <div className="input-icon">
                        <img
                          src={password}
                          className="img-fluid"
                          width="16"
                          height="16"
                          alt="password"
                        />
                      </div>
                      <input
                        type="password"
                        autoComplete="off"
                        className="form-control"
                        id="password"
                        value={user.password}
                        name="password"
                        placeholder="Password"
                        onChange={userInput}
                      />
                    </div>
                    <div className="d-flex justify-content-center gap-4 pb-4">
                      <div className="login-button">
                        <button
                          type="submit"
                          className="btn"
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              <span className="sr-only">Loading...</span>
                            </>
                          ) : (
                            "Login"
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="text-center mb-4">
                <img
                  src={Logo}
                  className="img-fluid w-100"
                  style={{ maxWidth: "200px" }}
                  alt="sign in"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Login;
